import {Component, OnInit} from '@angular/core';
import {PaginationModel} from "@alfresco/adf-core";
import {ProcessService} from "../../services/process.service";
import {MatDialog} from "@angular/material/dialog";
import {ViewProcessComponent} from "../view-process/view-process.component";
import {ContentActionRef} from "@alfresco/adf-extensions";
import {from, Observable, Subject} from "rxjs";
import {FormProcessusDialogComponent} from "../form-processus-dialog/form-processus-dialog.component";
import {map, switchMap, takeUntil, toArray} from "rxjs/operators";
import {PageEvent} from "@angular/material/paginator";
// @ts-ignore
import {AppService} from '../../../../../aca-shared/src/lib/services/app.service';
import {ActivatedRoute} from "@angular/router";

@Component({
  standalone: false,
  selector: 'my-processes',
  templateUrl: './my-processes.component.html',
  styleUrls: ['../../ui/workflow-page.scss'],
})
export class MyProcessesComponent implements OnInit {

  public processes$;
  public schema: any;
  public pagination: PaginationModel;
  public actions: Array<ContentActionRef> = [];
  public onDestroy$: Subject<boolean> = new Subject<boolean>();
  public isValidPath = true;
  public showAll: any;
  public fromDate: Date;
  public toDate: Date;
  public offset: number = 0;
  public limit: number = 15;
  public loading$: any;
  public currentPage: number = 0;
  public appNavNarMode$: Observable<'collapsed' | 'expanded'>;
  private showEnCours: boolean = true;

  constructor(private processService: ProcessService,
              private router: ActivatedRoute,
              private dialog: MatDialog,
              private appService: AppService) {
    this.appNavNarMode$ = appService.appNavNarMode$.pipe(takeUntil(this.onDestroy$));
  }

  ngOnInit() {
    this.initProccesses(true);
    this.router.queryParams.subscribe(params => {
      if (params['id']) {
        let modal = this.dialog.open(ViewProcessComponent, {
          maxWidth: '1000px',
          width: '100%',
          minHeight: '400px',
          data: {obj: {id: params['id']}}
        })
        modal.afterClosed().subscribe(() => {
          this.initProccesses(this.showEnCours);
        });
      }
    });
  }

  trackByActionId(_: number, action: ContentActionRef) {
    return action.id;
  }

  initProccesses(en_cours: boolean = true) {
    this.pagination = new PaginationModel({
      pageSize: this.limit,
    });
    this.processes$ = this.processService.getProcessesForCurrentUser(en_cours, this.offset, this.limit).pipe(
      switchMap((response: any) => {
        const pagination = response.list.pagination;
        this.pagination.totalItems = pagination.totalItems;
        return from(response.list.entries || []);
      }),
      map((entry: any) => entry.entry),
      map((process: any) => {
        return {...process, processDefinitionLabel: this.formatText(process.processDefinitionKey)};
      }),
      toArray()
    );

    this.schema = [
      {type: 'text', key: 'id', title: 'ID', sortable: true},
      {type: 'text', key: 'processDefinitionLabel', title: 'Processus', sortable: true},
      {type: 'text', key: 'startedAt', title: 'Date de début', sortable: true},
      {type: 'text', key: 'startUserId', title: 'Créé par', sortable: true},
      {type: 'text', key: 'completed', title: 'Statut', sortable: false},
      {type: 'text', key: 'endedAt', title: 'Fini le', sortable: false},
    ];
  }

  formatText(input: string): string {
    let text = input.replace(/([A-Z])/g, ' $1').trim();
    text = text.charAt(0).toUpperCase() + text.slice(1);
    return text;
  }


  onRowClick(event: any) {
    let modal = this.dialog.open(ViewProcessComponent, {
      maxWidth: '1000px',
      width: '100%',
      minHeight: '400px',
      data: event
    })
    modal.afterClosed().subscribe(() => {
      this.initProccesses(this.showEnCours);
    });
  }

  nouveauProcessus() {
    let modal = this.dialog.open(FormProcessusDialogComponent, {
      width: '1440px',
    })
    modal.afterClosed().subscribe(() => {
      this.initProccesses(this.showEnCours);
    });
  }

  showProcessFinished() {
    this.showEnCours = !this.showEnCours;
    // Réinitialiser la pagination
    this.offset = 0;
    this.limit = 15;
    this.currentPage = 0;
    this.initProccesses(this.showEnCours);
  }

  onPageChange($event: PageEvent) {
    this.offset = $event.pageIndex * $event.pageSize;
    this.limit = $event.pageSize;
    this.currentPage = $event.pageIndex;
    this.initProccesses(this.showEnCours);
  }

  toggleClick() {
    this.appService.toggleAppNavBar$.next();
  }

  filterResults() {
    if (this.fromDate && this.toDate) {
      if (this.fromDate > this.toDate) {
        this.isValidPath = false;
      } else {
        this.isValidPath = true;
        this.initProccesses(this.showEnCours);
      }
    }
  }

  copyLink(row: any) {
    let start = location.href.includes('localhost') ? '/#' : '/aca/#';
    let url = window.location.origin + start + '/my-processes?id=' + row.id;
    navigator.clipboard.writeText(url).then(() => {
      alert("Lien copié dans le presse-papier")
    });
  }
}
